import { Box, Grid, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoreInput from "../../core/inputs/CoreInput";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreButton from "../../core/inputs/CoreButton";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import {
  API_METHOD_POST,
  ENTITY_STATUS,
  PERMISSION_TYPES,
} from "../../config/constants";
import { api_request } from "../../store/actions/commonAction";
import {
  FETCH_PERMISSION_SEARCH_SUCCESS,
  INSERT_TABLE_DATA_ERROR,
  INSERT_TABLE_DATA_SUCCESS,
} from "../../store/types/manageDataTypes";
import CoreAsyncSelect from "../../core/inputs/CoreAsyncSelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxHeight: 570,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

export default function AddRoleAndPermission({ show, onClose, table }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [role, setRole] = useState("");
  const [priority, setPriority] = useState("");
  const [_status, set_status] = useState(ENTITY_STATUS["active"]);
  const [defaultTool, setDefaultTool] = useState("");

  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState(PERMISSION_TYPES["parent"]);
  const [link, setLink] = useState("");
  const [icon, setIcon] = useState("");
  const [parentId, setParentId] = useState(null);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  const onSubmit = (e) => {
    e.preventDefault();
    let body = null;
    if (table === "Roles") {
      body = { role, priority, _status, defaultTool };
    } else {
      body = { name, label, type, link, icon, _status, parentId };
    }
    dispatch(
      api_request(
        API_METHOD_POST,
        `/data/${table}/insert`,
        body,
        null,
        null,
        INSERT_TABLE_DATA_SUCCESS,
        INSERT_TABLE_DATA_ERROR,
        true,
        false,
        true
      )
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {table === "Roles" ? (
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <CoreInput
                label="role"
                value={role}
                onChange={(e) => {
                  setRole(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                label="priority"
                value={priority}
                onChange={(e) => {
                  setPriority(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreAutoComplete
                onChange={(id, val) => {
                  set_status(val?.value);
                }}
                style={{ width: "100%" }}
                value={_status}
                options={Object.keys(ENTITY_STATUS).map((item) => {
                  return {
                    value: ENTITY_STATUS[item],
                    label: ENTITY_STATUS[item],
                  };
                })}
                label="_status"
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                label="defaultTool"
                value={defaultTool}
                onChange={(e) => {
                  setDefaultTool(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <CoreInput
                label="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                label="label"
                value={label}
                onChange={(e) => {
                  setLabel(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreAutoComplete
                onChange={(id, val) => {
                  setType(val?.value);
                }}
                style={{ width: "100%" }}
                value={type}
                options={Object.keys(PERMISSION_TYPES).map((item) => {
                  return {
                    value: PERMISSION_TYPES[item],
                    label: PERMISSION_TYPES[item],
                  };
                })}
                label="type"
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                label="link"
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreInput
                label="icon"
                value={icon}
                onChange={(e) => {
                  setIcon(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CoreAutoComplete
                onChange={(id, val) => {
                  set_status(val?.value);
                }}
                style={{ width: "100%" }}
                value={_status}
                options={Object.keys(ENTITY_STATUS).map((item) => {
                  return {
                    value: ENTITY_STATUS[item],
                    label: ENTITY_STATUS[item],
                  };
                })}
                label="_status"
              />
            </Grid>
            <Grid item xs={6}>
              <CoreAsyncSelect
                display={(item) => {
                  return { value: item.id, label: item.name };
                }}
                onChange={(val) => {
                  setParentId(val?.value);
                }}
                valueColumn="id"
                value={parentId}
                reducerVar="fetchPermissionSearchResults"
                apiPath="/data/Permissions"
                query={{}}
                loadType={null}
                successType={FETCH_PERMISSION_SEARCH_SUCCESS}
                errorType={null}
                loading={true}
              />
              {/* <CoreInput
                label="parentId"
                value={parentId}
                onChange={(e) => {
                  setParentId(e.target.value);
                }}
              /> */}
            </Grid>
          </Grid>
        )}
        <CoreButtonContainer>
          <CoreButton onClick={onSubmit}>Submit</CoreButton>
        </CoreButtonContainer>
      </Box>
    </Modal>
  );
}
